import { Component, Input } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-debug-value',
  template: `
    <span *ngIf="isEnabled" class="debug-badge">
      <span class="debug-badge-label">🐞 {{ title }}</span>
      <pre class="debug-badge-value">{{ value | json }}</pre>
    </span>
  `,
  styles: [
    `
      :host {
        position: relative;
        display: inline-block;
        width: 0;
        height: 0;
        overflow: visible;
        z-index: 9999;
      }

      .debug-badge {
        position: absolute;
        top: 0;
        left: 0;
      }

      .debug-badge-label {
        display: inline-block;
        padding: 2px 6px;
        border-radius: 10px;
        background: #ffd43b;
        color: #000;
        font: 11px/1.4 monospace;
        white-space: nowrap;
        cursor: help;
      }

      .debug-badge-value {
        display: none;
        position: absolute;
        top: 100%;
        left: 0;
        margin: 4px 0 0;
        padding: 6px 8px;
        min-width: 200px;
        max-width: 60vw;
        max-height: 50vh;
        overflow: auto;
        border: 1px solid #888;
        background: #fffbe6;
        color: #000;
        font: 12px/1.4 monospace;
        white-space: pre-wrap;
        word-break: break-all;
      }

      .debug-badge:hover .debug-badge-value {
        display: block;
      }
    `,
  ],
})
export class DebugValueComponent {
  @Input() title?: string = 'Debug';
  @Input() value: unknown;

  readonly isEnabled = !environment.production;
}
